import React from 'react';
import { Navigate } from 'react-router-dom';

export default function RoomDetails() {
  return <Navigate to="/rooms" replace />;
}
